import React from 'react';
import StudentBulkTransfer from './StudentBulkTransfer';
import { PermisionDenied } from '../../../views/pages/manage/common/commonComponents';
import { useGetPermissions } from '../../../layouts/customHook';

const BulkTransferAccessGuard = () => {

    const userPermissions = useGetPermissions("studentTransferRequestBulk");
    
    return (  
        userPermissions
        ? <StudentBulkTransfer userPermissions={userPermissions}/>
        : <PermisionDenied/>
    );
}
 
export default BulkTransferAccessGuard;